import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useDayRender } from 'react-day-picker';
import classes from './DayPicker.module.css';
import clsx from 'clsx';

const isSameDay = (date1, date2) => {
    if (!date1 || !date2) return false;

    return (
        date1.getDate() === date2.getDate() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getFullYear() === date2.getFullYear()
    );
};

export default function CustomDay({ date, displayMonth, enabledDays = [] }) {
    const buttonRef = useRef(null);
    const dayRender = useDayRender(date, displayMonth, buttonRef);

    if (dayRender.isHidden) {
        return <div role="gridcell"></div>;
    }

    if (!dayRender.isButton) {
        return <div {...dayRender.divProps} />;
    }

    const isDisabled = !enabledDays.some((enabledDay) => isSameDay(enabledDay, date));

    return (
        <button
            name="day"
            ref={buttonRef}
            {...dayRender.buttonProps}
            disabled={dayRender.buttonProps.disabled || isDisabled}
            className={clsx(dayRender.buttonProps.className, classes.dayButton)}
        />
    );
}

CustomDay.propTypes = {
    date: PropTypes.instanceOf(Date).isRequired,
    displayMonth: PropTypes.instanceOf(Date).isRequired,
    enabledDays: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
};
